// extracted by mini-css-extract-plugin
module.exports = {"drawArrow":"styles_drawArrow__fH4d1","draw":"styles_draw__FnMIF"};